import React from 'react';
import { node, string } from 'prop-types';

const Header = props => (
  <span className={`header-text ${props.className}`} data-qa-id="header-text">
    {props.children}
  </span>
);

Header.propTypes = {
  children: node,
  className: string,
};

Header.defaultProps = {
  children: undefined,
  className: '',
};

export default Header;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-header/Header.scss');